<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Autorização do médico para telemedicina."
    [(visible)]="showDialog"
    header="Telemedicina"
    [appendTo]="'body'"
    styleClass="telemedicina-dialog"
    [breakpoints]="{ '1100px': '45vw', '800px': '60vw', '500px': '95vw' }"
>
    <ng-template #content>
        <form [formGroup]="telemedicinaForm" class="grid grid-cols-1 md:grid-cols-12 gap-3 mt-2">
            <!-- Tipo à esquerda -->
            <div class="col-span-1 md:col-span-6">
                <label for="tipo" class="block mb-2 font-semibold">Tipo</label>
                <p-select id="tipo" class="w-full" formControlName="tipo" [options]="tiposOptions()" optionLabel="nmTipoTelemedicina" optionValue="nmTipoTelemedicina" [appendTo]="'body'" />
                @if (campoInvalido('tipo')) {
                    <small class="erro-campo">{{ mensagemErroCampo('tipo') }}</small>
                }
            </div>

            <div class="col-span-1 md:col-span-3">
                <label for="dataInicio" class="block mb-2 font-semibold">Data Início</label>
                <p-datepicker id="dataInicio" formControlName="dataInicio" dateFormat="dd/mm/yy" [iconDisplay]="'input'" [showIcon]="true" [appendTo]="'body'" class="w-full" />
                @if (campoInvalido('dataInicio')) {
                    <small class="erro-campo">{{ mensagemErroCampo('dataInicio') }}</small>
                }
            </div>
        </form>
    </ng-template>

    <ng-template #footer>
        <div class="flex justify-end gap-2 w-full">
            <p-button label="Cancelar" severity="secondary" (onClick)="onCancel()"></p-button>
            <p-button label="Salvar" icon="pi pi-check" [disabled]="telemedicinaForm.invalid" (onClick)="onSave()"></p-button>
        </div>
    </ng-template>
</p-dialog>
